




































import BttPopup from '@/components/popup/btt/BttPopup.vue'
import FooterButton from '@/components/popup/btt/FooterButton.vue'
import BankImg from '@/components/image/BankImg.vue'
import Translation from '@/mixins/Translation'
import {Form, FormItem, Input} from 'element-ui'
import {mask} from 'vue-the-mask'
import {forEach} from 'lodash'
import {Component, Mixins, Watch, Prop, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import PopupHandlerMixin from '@/mixins/popupHandler'

const biz = namespace('biz')
const banks = namespace('banks')
const layout = namespace('layout')
const gtm = namespace('gtm')

interface Errors {
  number: boolean
  owner: boolean
}

@Component({
  components: {
    BttPopup,
    FooterButton,
    BankImg,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
  },
  directives: {mask},
})
export default
class BankAccountFormPopup extends Mixins(Translation, PopupHandlerMixin) {
  @biz.State('id') bizId
  @banks.Action('getOwner') getOwner
  @banks.Action('getBanks') getBanks
  @banks.Action('createBank') createBank
  @banks.Mutation('clearBankCode') clearBankCode
  @banks.State('owner') owner
  @banks.State('selectedBankCode') selectedBankCode
  @banks.Mutation('updateOwner') updateOwner
  @layout.Mutation('updateError') updateError
  @gtm.Action('logEventWithGroups') logEventWithGroups:
    (payload: LogEventWidthGroupsPayload) => void

  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: false, type: Boolean}) value: boolean

  @Ref('accountInput') readonly accountInput: Input

  open: boolean = false

  errors: Errors = {
    number: true,
    owner: true,
  }

  bankCode: string = ''
  number: string = ''
  ownerStatus: string = ''
  ownerLoading: boolean = false
  isOwnerVisible: boolean = false
  isFooter: boolean = false

  get ownerError() {
    const {ts} = this
    if(this.number === '') {
      return `${ts('bank-account-number')}를 ${ts('input')}해주세요.`
    } else if(this.ownerStatus === 'failed') {
      return `${ts('bank-account-owner')}를 찾지 못하였습니다. ${ts('bank')} ${ts('bank-account-number')}를 ${ts('confirm')}해주세요.`
    } else if(this.ownerStatus === '') {
      return `${ts('bank-account-owner')}를 ${ts('confirm')}해주세요.`
    }
    return ''
  }

  get rules() {
    const {ts} = this
    return {
      number: [
        {
          required: true,
          type: 'string',
          message: `${ts('bank-account-number')}를 ${ts('input')}해주세요.`,
          trigger: 'change',
        },
        {
          validator: (_, value, callback) => {
            let callbackResult = undefined as any
            if(this.ownerStatus === 'failed') {
              callbackResult = new Error(`${ts('bank-account-owner')}를 찾지 못하였습니다. ${ts('bank')} ${ts('bank-account-number')}를 ${ts('confirm')}해주세요.` as any)
            }
            return callback(callbackResult)

          },
          trigger: ['change', 'blur'],
        },
        {
          validator: (_, value, callback) => {
            let callbackResult = undefined as any
            if(!this.owner) {
              callbackResult = new Error(`${ts('bank-account-owner')}를 ${ts('confirm')}해주세요.` as any)
            }
            return callback(callbackResult)

          },
          trigger: [''],
        },
      ],
      owner: [
        {
          required: true,
          type: 'string',
          message: `${ts('bank-account-owner')}를 ${ts('input')}해주세요.`,
          trigger: 'change',
        },
      ],
    }
  }

  get isFormError(): boolean {
    const errors = {...this.errors}
    let error = false
    forEach(errors, (value) => {
      if(value) {
        error = true
        return false
      }
    })
    return error
  }

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
    if(value && this.selectedBankCode) {
      this.$nextTick(() => {
        this.accountInput?.focus()
      })
    }
    if(!value) {
      this.onClosePopup()
      this.$emit('close')
      this.resetFormData()
    }
  }

  @Watch('selectedBankCode', {immediate: true})
  __selectedBankCode(val) {
    this.bankCode = val
  }

  @Watch('isFormError')
  __isFormError(val) {
    this.isFooter = !val
  }

  onOwnerVisible() {
    this.isOwnerVisible = Boolean(this.owner)
  }

  onValidate(field, value) {
    this.errors[field] = !value
    this.errors = {...this.errors}
  }

  searchOwner() {
    if(!this.number || this.ownerStatus === 'loading') {
      return
    }
    this.ownerLoading = true
    this.getOwner({
      bankCode: this.bankCode,
      number: this.number,
    })
      .then(() => {
        if(!this.owner) {
          this.ownerStatus = 'failed'
        } else {
          this.ownerStatus = 'success'
        }
        this.onOwnerVisible()
      })
      .catch((error) => {
        this.ownerStatus = ''
        this.updateError({
          id: 'get-owner',
          message: `${this.ts('bank-account-owner')}를 조회하는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
      .finally(() => {
        this.ownerLoading = false
      })
  }

  onCreateAccount() {
    const el = this.$refs.form as any
    el.validateField('number')

    if(this.ownerStatus === 'success') {
      const {bankCode, number, owner, bizId} = this
      this.createBank({bankCode, number, owner, bizId})
        .then(() => {
          this.logEventWithGroups({
            eventType: 'complete',
            eventProperties: {
              'complete_type': 'success',
              'workflow': 'create_bank_acccount_manual'
            }
          })
          this.getBanks()
          this.onClosePopup()
        })
        .catch((error) => {
          this.logEventWithGroups({
            eventType: 'complete',
            eventProperties: {
              'complete_type': 'fail',
              'workflow': 'create_bank_acccount_manual'
            }
          })
          this.updateError({
            id: 'create-bank',
            message: `${this.ts('bank-account')}를 추가하는데 ${this.ts('failed')}하였습니다.`,
          })
          throw error
        })
    }
  }
  onClosePopup() {
    this.onHandlePopup(false)
  }
  onClickBankImg() {
    this.$emit('open-code-select-popup')
    this.onClosePopup()
  }

  onHandlePopup(value) {
    this.$emit('input', value)
  }

  resetFormData() {
    this.number = ''
    this.isOwnerVisible = false
    this.updateOwner('')
    this.clearBankCode()
    this.ownerStatus = ''
  }
}
